export const getClosest = (arr, num, accessor) => {
  if (arr.length) {
    let closest = arr[0];
    if (accessor && arr[0]) {
      closest = arr[0][accessor];
    } else {
      return null;
    }
    for (let ii = 0, nn = arr.length; ii < nn; ii++) {
      let currentValue = arr[ii];
      if (arr[ii] && accessor) {
        currentValue = arr[ii][accessor];
      }
      const closestDiff = Math.abs(num - closest);
      const currentDiff = Math.abs(num - currentValue);
      if (currentDiff < closestDiff) {
        closest = currentValue;
      }
    }
    return closest;
  }
};

export const getRoundedToNextTenPercent = (value) => {
  // Rounds percentage values between
  // 0 and 1, or 0 and -1, to the next
  // Ten percent. So 0.83 becomes 0.9.
  // -0.83 becomes -0.9. And so on.
  if (value > 0) {
    return Math.ceil(value * 10) / 10;
  }
  if (value < 0) {
    return Math.floor(value * 10) / 10;
  }
  return 0;
};

export const isEven = (value) => {
  return value === parseFloat(value) && !(value % 2);
};

export const isFloat = (value) => {
  const str = value.toString();
  if (str.indexOf('.') !== -1) {
    return true;
  }
};

export const isOdd = (value) => {
  return value === parseFloat(value) && Boolean(value % 2);
};

export const isValid = (value) => {
  if (value || value === 0) {
    if (value !== Infinity) {
      return true;
    }
  }
  return false;
};

export const limitToRange = (value, range) => {
  if (!range || !range.length) {
    return value;
  }
  const lower = range[0];
  const upper = range[1];
  let limitedValue = value;
  limitedValue = limitedValue < lower ? lower : limitedValue;
  limitedValue = limitedValue > upper ? upper : limitedValue;
  return limitedValue;
};

export const toOrdinal = (value) => {
  return [11, 12, 13].indexOf(value % 100) > -1
    ? `${value}th`
    : value +
        ['th', 'st', 'nd', 'rd', 'th', 'th', 'th', 'th', 'th', 'th'][
          value % 10
        ];
};
